module.exports = __webpack_public_path__ + "media/src/images/list2-45afa69c237e1061f86a5577769da3c6.png";